import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnLocation, SnMedia } from '@lib/api/entities';
import { SnLocationsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';

import { SnLocationFieldsGeneratorService } from '../../services/location-fields-generator.service';

@Component({
  selector: 'sn-location-media-dialog',
  templateUrl: './location-media-dialog.component.html',
  styleUrls: ['./location-media-dialog.component.scss'],
})
export class LocationMediaDialogComponent implements OnDestroy {
  public readonly form = new UntypedFormGroup({});
  public readonly formFields: SnFormFieldConfig[] = [
    this._locationFieldsGenerator.getFileUploadField({
      className: 'location-media',
    }),
  ];

  public formModel: any = {};
  public isLoading = false;
  public media: SnMedia[];

  private readonly _destroy$ = new Subject<void>();
  constructor(
    private readonly _locationsAPI: SnLocationsAPI,
    private readonly _locationFieldsGenerator: SnLocationFieldsGeneratorService,
    private readonly _dialogRef: MatDialogRef<LocationMediaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly location: SnLocation,
  ) {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this.isLoading = true;
    const data = this.form.value;

    this._locationsAPI
      .updateLocation(this.location.id, this._transformToFormData(data))
      .pipe(takeUntil(this._destroy$))
      .subscribe((location) => {
        this.media = location.media;
        this.isLoading = false;
        this._dialogRef.close();
      });
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  private _transformToFormData(data: Object): FormData {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (key) {
        case 'files':
          data[key].forEach((file) => {
            file.description = file.name;
            formData.append('files', file, file.name);
          });
          break;
        default:
          formData.append(key, data[key]);
      }
    });

    return formData;
  }
}
